import { mimeFromFilename } from './mimeFromFilename';

/**
 * An email's own attachments, opened in Dossier (#321). Served by
 * GET /api/attachments/:id/email/attachments/:index.
 */

export const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

/**
 * What the preview modal can show from an email. Not SVG or HTML: the server
 * sends those as bytes to download, never as something to render.
 */
const SHOWABLE = new Set([
  'application/pdf', 'image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/bmp',
  'text/plain', 'text/csv', 'text/markdown', 'application/json', DOCX_MIME,
]);

export const emailPartPath = (attachmentId: string, index: number) =>
  `/attachments/${encodeURIComponent(attachmentId)}/email/attachments/${index}`;

/**
 * The type to preview an email attachment as, or '' when it should just be
 * downloaded. The email's own type is trusted only when it is one Dossier
 * shows; a generic one (Outlook often says application/octet-stream) falls
 * back to the file's extension.
 */
export function emailPartMime(name: string, mime: string): string {
  const claimed = (mime || '').split(';')[0].trim().toLowerCase();
  if (SHOWABLE.has(claimed)) return claimed;
  const byName = mimeFromFilename(name);
  return SHOWABLE.has(byName) ? byName : '';
}
